import loadable from "@loadable/component";
import { ILog } from "@ihr-radioedit/inferno-core";
import { PageBlockInterface } from "../../../../core/page-blocks/Block.component";
import CoastShowFrontMatter from "../content/CoastShowFrontMatter.component";
import { isItemBlock, isFeedResult, isPublishRecord } from "@inferno/renderer-shared-core";

const CoastPreviousNextLoader = loadable(() => import("./CoastPreviousNextLoader.component"));

const log = ILog.logger("CoastItemReference.component");

const CoastItemReference = ({ block }: PageBlockInterface) => {
  if (!isItemBlock(block)) {
    log.error("No item on block", block);
    return null;
  }

  if (isFeedResult(block.item?.result)) {
    const content = block.item?.result.record;

    if (block.tags?.includes("display-hints/previous-next") && isPublishRecord(content)) {
      return <CoastPreviousNextLoader block={block} content={content} />;
    }
    if (block.tags?.includes("display-hints/front-matter") && isPublishRecord(content)) {
      return <CoastShowFrontMatter block={block} content={content} />;
    }
  }

  return null;
};

export default CoastItemReference;
